import React, { useMemo } from "react";
import { getSpritesheetUrl } from "../../../lib/wowHelpers";
import Icon from "../../Common/Icon";
import { getIcon } from "../Builds/WOWBuildsContainer";
import WowTooltip from "components/Tooltips/WowTooltip";

const TalentsList = (props) => {
  const { iconImg, label, rows, specType, classType, selectedNodes } = props;

  const treeType = useMemo(() => {
    const sanitizedLabel = label.toLowerCase().replace(" ", "_");
    return sanitizedLabel === classType.toLowerCase() ? "class" : "spec";
  }, [label, classType]);
  const spritesheet = getSpritesheetUrl(classType, specType, treeType);

  return (
    <div className="talents-list-container">
      <div className="talents-list-header">
        <Icon iconSize="20px" classType={"circle"} staticDataImg={iconImg} />
        <div className="tree-label">{label} Talents</div>
      </div>
      <div className="talents-list">
        {rows.map((talent, index) => {
          let spellId, spriteData, nodeId, talentName, talentDescription;
          if (talent[1].spells.length > 1) {
            for (let i = 0; i < talent[1].spells.length; i++) {
              const spell = talent[1].spells[i];
              // Use nodeEntryId for data from WCL and the definition ID for data from the Blizzard API.
              if (selectedNodes.includes(spell.nodeEntryId.toString()) || selectedNodes.includes(spell.definitionId.toString())) {
                spellId = spell.spellId;
                spriteData = spell.sprite;
                nodeId = spell.nodeEntryId;
                talentName = talent[1].spells[i].name;
                talentDescription = talent[1].spells[i].description;
              }
            }
          } else {
            const spell = talent[1].spells[0];
            spellId = spell.spellId;
            spriteData = spell.sprite;
            nodeId = spell.nodeEntryId;
            talentName = talent[1].spells[0].name;
            talentDescription = talent[1].spells[0].description;
          }

          if (!selectedNodes.includes(nodeId?.toString())) {
            return null;
          }

          {
            /* I am using only the spells description here because I dont know how many points 
            are dedicated, as well as the number of points allocated are not shown on the talent 
            list page. */
          }
          return (
            <WowTooltip type="spell" id={spellId}>
              {getIcon(1, spellId, "transparent", "30px", index, spriteData, spritesheet)}
            </WowTooltip>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(TalentsList);
